<template lang='pug'>
v-col(sm='12')
  v-row(no-gutters)
    v-col(style='padding: 0 20px')
      md-card
        md-card-header.md-card-header-icon.md-card-header-green
          .card-icon
            md-icon brush
          h4.title
            | {{ $t("webChannel.buttonAppearanceSettings.title") }}
        md-card-content
          form.form-horizontal(action method='post')
            .md-layout
              .md-layout-item.md-size-100
                .file-input.img-circle(
                  style='display: block; max-width: none')
                  h5.card-title(style='text-align: center')
                    | {{ $t("webChannel.buttonAppearanceSettings.subitems.icon") }}
                  .image-container
                    v-img.overlayContainer(
                      :aspect-ratio='1'
                      contain,
                      :src='canalWebData[device].floatingButtonIconUrl')
                      .overlay
                        .text
                          span(style='text-decoration: underline')
                            | {{
                            | $t(
                            | "webChannel.buttonAppearanceSettings.subitems.change"
                            | )
                            | }}
                          v-icon(small style='color: white') mdi-paperclip
                        input.custom-fileinput(
                          type='file'
                          @change='checkFileSize($event, ".messageIcon"); updateFile($event, device);'
                          name='circle'
                          style='cursor: pointer')
                  span.messageIcon(
                    style='text-align: center'
                    v-bind:style="{ color: errorSizeImg }")
                    | {{
                    | $t(
                    | "webChannel.appearanceSettings.subitems.maxFileSize"
                    | )
                    | }}
              .md-layout-item.md-size-100
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.interface"
                    | )
                    | }}
                  md-select(v-model='device')
                    span(v-for='(label, i) in labels', :key='i')
                      md-option(:value='label.toLowerCase()') {{ label }}
              .md-layout-item.md-size-100
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.selectPosition"
                    | )
                    | }}
                  md-select(v-model='canalWebData[device].position')
                    span(v-for='(label, i) in positions', :key='i')
                      md-option(:value='label.code') {{ label.displayName }}
              .md-layout-item.md-size-100
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.shape"
                    | )
                    | }}
                  md-select(v-model='canalWebData[device].buttonShape')
                    span(v-for='(label, i) in shape', :key='i')
                      md-option(:value='label.code') {{ label.displayName }}
              .md-layout-item.md-size-50
                div(
                  v-if='canalWebData[device].buttonShape === "roundBorder"'
                  style='display: flex; margin-top: 30px; justify-content: center')
                  v-btn(
                    :style='{ "border-radius": canalWebData[device].buttonBorderRadiusPx + "px", "background-color": "#43a047", width: canalWebData[device].buttonWidth + "px", height: canalWebData[device].buttonHeight + "px" }')
              .md-layout-item.md-size-50
                div(
                  v-if='canalWebData[device].buttonShape === "roundBorder"'
                  style='margin-top: 30px')
                  v-slider(
                    v-model='canalWebData[device].buttonBorderRadiusPx'
                    step='1'
                    min='5'
                    max='30')
              .md-layout-item.md-size-50
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.backgroundColor"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonBackgroundColor')
                md-field(
                  v-if='canalWebData[device].buttonShape !== "circle"'
                  style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.height"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonHeight')
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.marginLeft"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonMarginLeft')
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.marginBottom"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonMarginBottom')
              .md-layout-item.md-size-50
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.borderColor"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonBorderColor')
                md-field(
                  v-if='canalWebData[device].buttonShape !== "circle"'
                  style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.width"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonWidth')
                md-field(
                  v-if='canalWebData[device].buttonShape === "circle"'
                  style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.size"
                    | )
                    | }}
                  md-input(v-model='sizeOfButton')
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.marginRight"
                    | )
                    | }}
                  md-input(v-model='canalWebData[device].buttonMarginRight')
              .md-layout(v-if="canalWebData.tenantName === 'inss'")
                .md-layout-item(style='margin: auto;')
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.enableWebChannelExit"
                    | )
                    | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                  'text-success': canalWebData.isWebChannelExit,\
                  'text-danger': !canalWebData.isWebChannelExit\
                }")
                    | {{
                    | canalWebData.isWebChannelExit
                    | ? $t("commonWords.enabled")
                    | : $t("commonWords.disabled")
                    | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isWebChannelExit')
            .md-layout(v-if="canalWebData.tenantName === 'inss'")
              .md-layout-item.md-size-100
                md-field(:class='idleWarningTimeClass')
                  label
                    | {{
                    | $t(
                    | "webChannel.buttonAppearanceSettings.subitems.reappearWebChannel"
                    | )
                    | }}
                  md-input(v-model='canalWebData.reappearWebChannel' type='number' min='0' :required='canalWebData.isWebChannelExit')
                  span(v-if='canalWebData.reappearWebChannel <= 0 && canalWebData.isWebChannelExit' class="md-error error-message" style='font-size: 10px; margin-bottom: 15px') {{$t('sessionControl.requiredField')}}
</template>

<script>
import axios from 'axios'
import { mapFields } from 'vuex-map-fields'
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    },
    canalWebId: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      errorSizeImg: '',
      device: 'desktop',
      value: 10,
      file: null,
      labels: ['Desktop', 'Mobile'],
      positions: [
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.leftBottom'
          ),
          code: 'bottonLeft'
        },
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.rightBottom'
          ),
          code: 'bottonRight'
        },
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.leftSide'
          ),
          code: 'sideviewLeft'
        },
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.rightSide'
          ),
          code: 'sideviewRight'
        }
      ],
      shape: [
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.circle'
          ),
          code: 'circle'
        },
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.rectangular'
          ),
          code: 'square'
        },
        {
          displayName: this.$t(
            'webChannel.buttonAppearanceSettings.subitems.roundBorder'
          ),
          code: 'roundBorder'
        }
      ]
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    sizeOfButton: {
      get () {
        return this.canalWebData[this.device].buttonHeight
      },
      set (value) {
        this.canalWebData[this.device].buttonHeight = value
        this.canalWebData[this.device].buttonWidth = value
      }
    },
    idleWarningTimeClass () {
      return {
        'md-invalid': this.canalWebData.isWebChannelExit === true || this.canalWebData.reappearWebChannel <= 0
      }
    }
  },
  created () {
    if (typeof this.canalWebData['desktop'] === 'undefined') {
      this.canalWebData['desktop'] = {}
    }
    if (typeof this.canalWebData['mobile'] === 'undefined') {
      this.canalWebData['mobile'] = {}
    }
  },
  methods: {
    checkFileSize (event, classTag) {
      const fileInput = event.target

      if (fileInput.files && fileInput.files[0]) {
        const fileSize = fileInput.files[0].size
        const maxSize = 65 * 1024
        if (fileSize > maxSize) {
          this.errorSizeImg = '#f44336'
          fileInput.value = ''
        }
      }

      setTimeout(() => {
        this.errorSizeImg = ''
      }, 3000)
    },

    updateFile (files, device) {
      this.file = files.target.files[0]
      this.upload(this.file, device)
    },

    async upload (file, device) {
      const name = `${device}-avatar-button`
      const result = await this.$axios.post(
        `/assistant-configs/${this.assistantId}/webchannel/${this.canalWebId}/upload-link`,
        {
          fileMimeType: file.type,
          name
        }
      )
      const fullmock = result.data
      const form = new FormData()

      const mock = fullmock.preSigned

      Object.entries(mock.fields).forEach(([k, v]) => {
        form.append(k, v)
      })
      form.append('file', file)

      try {
        const uploadResponse = await axios.post(mock.url, form)
        if (uploadResponse.status === 204) {
          this.canalWebData[this.device].floatingButtonIconUrl = `https://${mock.bucket}.s3.us-east-2.amazonaws.com/${mock.filePath}?` + new Date().getTime()
        }
      } catch (e) {
        // TODO: tratar o erro
      }
    }
  }
}
</script>

<style scoped>
.custom-fileinput {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  opacity: 0;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #9c27b070;
}
.overlayContainer:hover .overlay {
  opacity: 1;
}
.text {
  color: white;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  white-space: nowrap;
}

.messageIcon {
  display: flex;
  justify-content: center;
  color: rgba(0,0,0,.6);
  line-height: 12px;
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 300;
}
</style>
